export { GgzcgV1DiagnosticReportAddEdit as Ggzcf2fV1DiagnosticReportAddEdit } from '../../GGZCg/v1/GgzcgV1DiagnosticReportAddEdit';
